/* Wizard-only loading boundary. Liquid owns the cold landing; the shared engine owns navigation. */
(function () {
  'use strict';
  // The Wizard's own picture rows (snippets/cq-wiz-images.liquid, script#cqw-images) join the shared picture map
  // (script#cqq-images) before the engine reads it. Aliased scenes (cq-v3-q-scene-<key>.webp pointed at the Wizard's
  // white-background cq-wiz-scene-<key>.webp) keep their product names from script#cqq-scenes with the studio wording.
  function mergePictures(root) {
    const read = el => { try { return el ? JSON.parse(el.textContent || '{}') : null; } catch (_) { return null; } };
    const target = root.querySelector('#cqq-images'), extra = read(root.querySelector('#cqw-images'));
    if (!target || !extra || target.dataset.cqwMerged === 'true') return;
    const map = Object.assign(read(target) || {}, extra);
    target.textContent = JSON.stringify(map); target.dataset.cqwMerged = 'true';
    const sceneEl = root.querySelector('#cqq-scenes'), scenes = read(sceneEl);
    if (!sceneEl || !scenes) return;
    Object.keys(scenes).forEach(key => {
      const pic = extra['cq-v3-q-scene-' + key + '.webp'];
      if (!pic || !/cq-wiz-scene-/.test(pic.src || '') || !scenes[key] || !scenes[key].alt) return;
      scenes[key].alt = String(scenes[key].alt).split(':')[0].trim() + ', shown on a white background. Configuration can vary.';
    });
    sceneEl.textContent = JSON.stringify(scenes);
  }
  function init() {
    const root = document.querySelector('[data-cqq-quiz="wizard"]');
    if (!root || root.cqwRuntimeLoader) return;
    root.cqwRuntimeLoader = true;
    mergePictures(root);
    if (window.CQWizIntro) window.CQWizIntro.install(root);
    const scope = root.closest('.shopify-section') || document;
    const entries = Array.from(scope.querySelectorAll('script[data-cqw-runtime]'));
    if (!entries.length) return;
    let pending = null, ready = false, startRequested = false, returnStartFocus = false, disposed = false;
    let boot = null, entranceWarm = null, keyboard = false, returningFocus = false;
    let requestedButton = null;
    const cancellers = new Set(), warmImages = [];
    const ENTRANCE_KEY = 'cqq:logo-entrance:v1:wizard';
    const motion = window.matchMedia ? window.matchMedia('(prefers-reduced-motion: reduce)') : {matches: false};
    const connection = window.navigator.connection;
    const calm = () => !!(motion.matches || root.closest('[data-cqv-motion-paused]') || (connection && connection.saveData));
    const entrancePlayed = () => { try { return sessionStorage.getItem(ENTRANCE_KEY) === '1'; } catch (_) { return false; } };
    let assets = {};
    try { assets = JSON.parse((root.querySelector('#cqq-assets') || {}).textContent || '{}') || {}; } catch (_) {}
    const asset = name => assets[name] || (root.dataset.cqqAssetBase || '') + name;
    const startButton = () => root.querySelector('[data-cqq-do="start"]');
    const busy = value => root.querySelectorAll('[data-cqq-do="start"]').forEach(button => {
      if (value) button.setAttribute('aria-busy', 'true'); else button.removeAttribute('aria-busy');
    });
    const status = document.createElement('p');
    status.className = 'cqv-q-note'; status.setAttribute('role', 'status'); status.hidden = true;
    const foot = root.querySelector('.cqv-q-foot'); if (foot) foot.appendChild(status);
    function announce(text) {
      // Mounting replaces the Liquid landing, including its original status node.
      if (!status.isConnected) (root.querySelector('.cqv-q-foot') || root).appendChild(status);
      status.hidden = false; status.textContent = text;
    }
    // A cold landing must not wait for a definition to remove the font gate.
    const reveal = () => { if (root.isConnected) root.classList.remove('cqq-fonts-pending'); };
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(reveal); else reveal();
    setTimeout(reveal, 1500);
    function warmEntrance() {
      if (calm() || keyboard || entrancePlayed()) return Promise.resolve(false);
      if (entranceWarm) return entranceWarm;
      entranceWarm = new Promise(resolve => {
        if (window.CQQuizLogoEntrance) { resolve(true); return; }
        const el = document.createElement('script');
        el.src = asset('cq-quiz-logo-entrance.js'); el.async = true;
        let settled = false;
        const cancel = () => finish(false);
        const timer = setTimeout(() => finish(false), 3000);
        function finish(ok) {
          if (settled) return;
          settled = true; cancellers.delete(cancel);
          clearTimeout(timer); el.onload = el.onerror = null;
          if (!ok) el.remove();
          resolve(ok && !!window.CQQuizLogoEntrance);
        }
        el.onload = () => finish(true); el.onerror = () => finish(false);
        cancellers.add(cancel);
        document.head.appendChild(el);
      }).then(ok => { if (!ok) entranceWarm = null; return ok; });
      // Warm the player's own official layers only after Start intent, never on hover or idle.
      ['logo', 'outer', 'body', 'mask-swoosh', 'mask-script', 'mask-white'].forEach(name => {
        const im = new Image(); im.decoding = 'async'; im.src = asset('cq-quiz-logo-' + name + '.png');
        warmImages.push(im);
      });
      return entranceWarm;
    }
    function beginStart(instant) {
      if (boot || disposed) return;
      const animate = !instant && !calm() && !entrancePlayed();
      const loaded = animate ? warmEntrance() : Promise.resolve(false);
      const overlay = document.createElement('div');
      overlay.className = 'cqq-start-moment cqw-boot'; overlay.tabIndex = -1;
      overlay.setAttribute('role', 'dialog'); overlay.setAttribute('aria-modal', 'true');
      overlay.setAttribute('aria-labelledby', 'cqw-boot-status');
      overlay.innerHTML = '<div class="cqq-start-logo" aria-hidden="true"></div><div class="cqw-boot-wait">' +
        '<div class="cqw-loading-mark" aria-hidden="true"><img width="1600" height="377" alt="" decoding="async"></div>' +
        '<p class="cqw-boot-status" id="cqw-boot-status" role="status" aria-live="polite">Getting your questions ready</p></div>';
      overlay.querySelector('img').src = asset('cq-quiz-logo-logo.png');
      overlay.toggleAttribute('data-cqw-loading-static', instant || calm());
      const behind = new Map();
      const shield = () => Array.from(root.children).forEach(el => {
        if (el === overlay || behind.has(el)) return;
        behind.set(el, el.inert); el.inert = true;
      });
      shield(); root.appendChild(overlay);
      const added = new MutationObserver(shield); added.observe(root, {childList: true});
      let player = null, done = !animate, enter = null, closed = false, timer = null, lineTimers = [];
      const stop = () => {
        clearTimeout(timer); lineTimers.forEach(clearTimeout); lineTimers = [];
        if (player) { player.cancel(); player = null; }
      };
      const detach = () => {
        closed = true; stop(); added.disconnect();
        overlay.removeEventListener('click', skip); overlay.removeEventListener('keydown', skip);
        behind.forEach((inert, el) => { el.inert = inert; });
        if (root.cqwBootStart === handoff) delete root.cqwBootStart;
        boot = null;
      };
      const proceed = () => {
        if (closed || !done || !ready || !enter) return;
        detach(); startRequested = false;
        busy(false);
        overlay.setAttribute('aria-hidden', 'true'); overlay.removeAttribute('aria-modal');
        // The layer stays hit-testable until it starts fading (is-out sets pointer-events:none), so a tap during the
        // hand-off can never pick a question 1 answer the visitor cannot see yet (2026-10-13 release check).
        const swallow = event => { if (!overlay.classList.contains('is-out')) { event.preventDefault(); event.stopPropagation(); } };
        overlay.addEventListener('click', swallow, true); overlay.addEventListener('pointerdown', swallow, true);
        // AJ 2026-10-12 19:13: a slower, calmer hand-off from the opening into question 1 (this one fade only).
        const slow = animate && !calm();
        if (slow) { root.style.setProperty('--cqq-swap-ms', '1100ms'); setTimeout(() => root.style.removeProperty('--cqq-swap-ms'), 1700); }
        // Safety net: if any navigation interrupts the engine's own fade and removal, never leave the layer covering the page.
        setTimeout(() => {
          if (!overlay.isConnected) return;
          overlay.classList.add('is-out');
          setTimeout(() => { if (overlay.isConnected) overlay.remove(); }, slow ? 1200 : 300);
        }, slow ? 4500 : 2500);
        // The engine fits and focuses the first question under this layer, then owns its normal fade/removal.
        enter(overlay);
      };
      const finish = () => {
        if (closed) return;
        done = true; stop();
        // Ready questions fade straight through white; only a pending runtime brings the waiting logo back.
        if (!ready || !enter) overlay.classList.remove('is-playing');
        proceed();
      };
      const skip = event => {
        if (event.type === 'keydown' && !['Enter', ' ', 'Spacebar', 'Escape'].includes(event.key)) {
          if (event.key === 'Tab') { event.preventDefault(); event.stopPropagation(); }
          return;
        }
        event.preventDefault(); event.stopImmediatePropagation(); finish();
      };
      // AJ 2026-10-05 (A100) and 2026-10-12 19:13: more than one line before the questions. The logo settles, then two
      // short lines in AJ's words, then question 1. A tap, Enter or Escape skips; reduced motion never gets here.
      const opening = () => {
        if (closed || done) return;
        const box = document.createElement('div'); box.className = 'cqw-boot-lines'; box.setAttribute('aria-hidden', 'true');
        box.innerHTML = '<p class="cqw-boot-line">It\u2019s time for the water <em>you really want.</em></p>' +
          '<p class="cqw-boot-line">First up, a few quick questions so we can help.</p>';
        overlay.appendChild(box); overlay.classList.add('is-lines');
        const said = overlay.querySelector('#cqw-boot-status'); if (said) said.textContent = 'It\u2019s time for the water you really want. First up, a few quick questions so we can help.';
        lineTimers.push(setTimeout(() => box.children[0].classList.add('is-in'), 350));
        lineTimers.push(setTimeout(() => box.children[1].classList.add('is-in'), 1700));
        lineTimers.push(setTimeout(finish, 3900));
      };
      const handoff = next => { if (!closed) { enter = next; proceed(); } };
      boot = {
        get entering() { return !!enter; },
        sync() { overlay.toggleAttribute('data-cqw-loading-static', instant || calm()); if (calm()) finish(); },
        proceed,
        cancel() { if (!closed) { detach(); overlay.remove(); } }
      };
      root.cqwBootStart = handoff;
      overlay.addEventListener('click', skip); overlay.addEventListener('keydown', skip);
      try { overlay.focus({preventScroll: true}); } catch (_) { overlay.focus(); }
      busy(true);
      status.hidden = true;
      if (!animate) return;
      try { sessionStorage.setItem(ENTRANCE_KEY, '1'); } catch (_) {}
      // A broken player or missing layer must never trap the loading dialog.
      timer = setTimeout(finish, 10000);
      loaded.then(ok => {
        if (closed || done) return;
        if (!ok || calm()) { finish(); return; }
        try {
          player = window.CQQuizLogoEntrance.play({element: overlay.querySelector('.cqq-start-logo'), assetBase: asset,
            onComplete: opening, onFirstFrame: () => { if (!closed && !done) overlay.classList.add('is-playing'); }});
        } catch (_) { finish(); }
      });
    }
    // Deep-link highlighting pulses the pause attribute for one microtask on cq_quiz_start.
    // Observe the settled preference, so that pulse cannot cancel an entrance already playing.
    const syncMotion = () => { Promise.resolve().then(() => { if (boot) boot.sync(); }); };
    if (motion.addEventListener) motion.addEventListener('change', syncMotion);
    if (connection && connection.addEventListener) connection.addEventListener('change', syncMotion);
    const pauses = new MutationObserver(syncMotion);
    for (let el = root; el; el = el.parentElement) pauses.observe(el, {attributes: true, attributeFilter: ['data-cqv-motion-paused']});
    function script(entry) {
      if (disposed || !root.isConnected) return Promise.reject(new Error('wizard_removed'));
      if (entry.dataset.cqwLoaded === 'true') return Promise.resolve();
      return new Promise((resolve, reject) => {
        const el = document.createElement('script');
        el.src = entry.dataset.src; el.async = false;
        if (entry.dataset.refillsUrl) el.dataset.refillsUrl = entry.dataset.refillsUrl;
        let settled = false;
        const cancel = () => finish(false);
        const timer = setTimeout(() => finish(false), 20000);
        function finish(ok) {
          if (settled) return;
          settled = true; cancellers.delete(cancel);
          clearTimeout(timer); el.onload = el.onerror = null;
          if (ok) { entry.dataset.cqwLoaded = 'true'; resolve(); }
          else { el.remove(); reject(new Error('wizard_load')); }
        }
        el.onload = () => finish(true); el.onerror = () => finish(false);
        cancellers.add(cancel);
        entry.parentNode.insertBefore(el, entry);
      });
    }
    function stylesheet(link) {
      if (link.dataset.cqwLoaded === 'true' || link.sheet) return Promise.resolve();
      return new Promise((resolve, reject) => {
        let settled = false;
        const finish = ok => {
          if (settled) return;
          settled = true; clearTimeout(timer); cancellers.delete(failed);
          link.removeEventListener('load', loaded); link.removeEventListener('error', failed);
          if (ok) { link.dataset.cqwLoaded = 'true'; resolve(); }
          else { link.removeAttribute('href'); reject(new Error('wizard_style')); }
        };
        const loaded = () => finish(true), failed = () => finish(false);
        const timer = setTimeout(failed, 20000);
        cancellers.add(failed);
        link.addEventListener('load', loaded); link.addEventListener('error', failed);
        link.href = link.dataset.cqwStyle;
      });
    }
    function mounted() {
      return new Promise((resolve, reject) => {
        const began = Date.now();
        function check() {
          if (disposed || !root.isConnected) { reject(new Error('wizard_removed')); return; }
          if (window.CQQuizV3 && window.CQQuizV3.instances.some(instance => instance.root === root)) { resolve(); return; }
          if (Date.now() - began > 20000) { reject(new Error('wizard_mount')); return; }
          setTimeout(check, 30);
        }
        check();
      });
    }
    function load() {
      if (pending) return pending;
      // The final runtime registers and immediately mounts restored/deep-linked results.
      // Await CSS before any runtime runs so no entry route can reveal an unstyled result.
      let chain = Promise.all(Array.from(scope.querySelectorAll('link[data-cqw-style]'), stylesheet));
      entries.forEach((entry, index) => { chain = chain.then(() => {
        if (index === entries.length - 1) returnStartFocus = document.activeElement === startButton();
        return script(entry);
      }); });
      pending = chain.then(mounted).then(() => {
        if (disposed || !root.isConnected) return;
        ready = true; status.remove();
        const button = startButton();
        if (boot) {
          busy(true);
          if (boot.entering) boot.proceed();
          else if (button) button.click();
          else boot.cancel();
        } else if (startRequested && button) button.click();
        else if (returnStartFocus && button && document.activeElement === document.body) button.focus({preventScroll: true});
      }).catch(() => {
        pending = null;
        const requested = startRequested || !!boot;
        if (boot) boot.cancel();
        startRequested = false;
        if (disposed || !root.isConnected) return;
        busy(false);
        const button = requestedButton && requestedButton.isConnected ? requestedButton : startButton();
        announce('The questions could not load. Select Start again to retry.');
        if (requested && button) {
          returningFocus = true;
          try { button.focus({preventScroll: true}); } finally { returningFocus = false; }
        }
      });
      return pending;
    }
    root.addEventListener('click', event => {
      const button = event.target.closest && event.target.closest('[data-cqq-do="start"]');
      if (!button || disposed) return;
      if (ready) {
        if (!boot && (keyboard || event.detail === 0)) beginStart(true);
        else if (!boot && !entrancePlayed() && !calm()) beginStart(false);
        return;
      }
      event.preventDefault(); event.stopImmediatePropagation();
      startRequested = true; requestedButton = button;
      beginStart(keyboard || event.detail === 0); load();
    }, true);
    root.addEventListener('keydown', () => { keyboard = true; }, true);
    root.addEventListener('pointerdown', () => { keyboard = false; }, true);
    const intent = event => {
      if (!disposed && !returningFocus && event.target.closest && event.target.closest('[data-cqq-do="start"]')) { warmEntrance(); load(); }
    };
    // Hover can happen during a scroll gesture; only Start focus, pointerdown or click starts loading.
    root.addEventListener('focusin', intent);
    root.addEventListener('pointerdown', intent);
    scope.addEventListener('shopify:section:unload', () => {
      disposed = true; if (boot) boot.cancel(); pauses.disconnect();
      cancellers.forEach(cancel => cancel());
      warmImages.forEach(im => im.removeAttribute('src')); warmImages.length = 0;
      if (motion.removeEventListener) motion.removeEventListener('change', syncMotion);
      if (connection && connection.removeEventListener) connection.removeEventListener('change', syncMotion);
    }, {once: true});
    let restore = false;
    try { const saved = JSON.parse(sessionStorage.getItem('cqq:wizard:v1')); restore = !!(saved && saved.v === 1 && saved.started); } catch (_) {}
    const query = new URLSearchParams(location.search);
    // AJ 2026-10-16 23:37 and 2026-10-17 02:31: the restyled report analyzer replaces the old report entry, so every
    // existing ?mode=report link (menu, emails, articles, sales templates) lands on /pages/water-report-analyzer with its
    // other parameters, and no link is re-pointed. The analyzer's own hand-off (?mode=report&from=analyzer) still opens
    // the report path below.
    if (!query.has('path') && query.get('mode') === 'report' && query.get('from') !== 'analyzer') {
      query.delete('mode');
      const base = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      try { location.replace(base + 'pages/water-report-analyzer' + (query.toString() ? '?' + query.toString() : '') + location.hash); return; } catch (_) {}
    }
    // The previous Wizard's report link (?mode=report) keeps opening the report path directly, so links in emails,
    // articles and sales templates keep working: it becomes ?start=1&path=report before the quiz reads the address.
    if (!query.has('path') && query.get('mode') === 'report') {
      query.delete('mode'); query.set('start', '1'); query.set('path', 'report');
      try { history.replaceState(history.state, '', location.pathname + '?' + query.toString() + location.hash); } catch (_) {}
    }
    const shared = query.has('m') || new URLSearchParams(location.hash.slice(1)).has('m');
    const deepStart = query.get('start') === '1' || location.hash === '#start';
    if (deepStart && !restore && !shared && !query.has('path') && !root.querySelector('[data-cqq-contact-state]')) beginStart(false);
    if (restore || query.has('path') || deepStart || shared) load();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
}());
